import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { Loader } from "semantic-ui-react";
import { useAgeReadyContext } from "../../AgeReadyContext/AgeReadyContext";

const PartnerStateContainer: React.FunctionComponent<{ children: any; }> = ({
  children,
}) => {
  const { partnerStore, caregiverStore } = useAgeReadyContext();

  const partnerIdExistsInStateButItsLogoDoesNot = (): boolean => {
    return !!caregiverStore.partnerCode && !getLogoByPartnerId(caregiverStore.partnerCode)
  }

  const getLogoByPartnerId = (partnerId: string): string | undefined => {
    return partnerStore.logosByPartnerId.get(partnerId);
  }

  useEffect(() => {
    if (partnerIdExistsInStateButItsLogoDoesNot()) {
      partnerStore.loadLogo(caregiverStore.partnerCode);
    }

    if (!!caregiverStore.partnerCode && !partnerStore.partnersByIdMap.has(caregiverStore.partnerCode)) {
      partnerStore.loadPartner(caregiverStore.partnerCode);
    }
  });

  if (!caregiverStore.partnerCode) {
    return children;
  }

  if (!!caregiverStore.partnerCode && !partnerStore.partnersByIdMap.has(caregiverStore.partnerCode)) {
    return (<Loader active />);
  }

  if (!!caregiverStore.partnerCode && !!partnerStore.partnersByIdMap.has(caregiverStore.partnerCode)) {
    return children;
  }
};

export default observer(PartnerStateContainer);